(function() {
  'use strict';

  function queryAll(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function getFocusable(root) {
    return queryAll(root, 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  var html = document.documentElement;
  var header = document.querySelector('.section-header');
  var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-drawer-toggle]'));
  var drawer = document.getElementById('MobileDrawer');
  var stickyEl = document.querySelector('sticky-header');
  if (!toggles.length || !drawer) return;
  // Handle pre-init intent: if flagged, animate open once ready
  // If pre-init forcibly opened, adopt state to avoid jump
  if ((window.__drawerIntendedOpen || drawer.classList.contains('will-open')) && !drawer.hidden) {
    window.__drawerIntendedOpen = false;
    drawer.classList.remove('will-open');
    // Defer to allow first frame styles to commit
    requestAnimationFrame(function(){ openDrawer(); });
  } else if (drawer.classList.contains('is-open') && !drawer.hidden) {
    state.open = true;
    toggles.forEach(function(t){ t.setAttribute('aria-expanded','true'); });
    setHeaderHeightVar();
    positionUnderHeader();
  }
  window.__drawerReady = true;

  var panel = drawer.querySelector('[data-drawer-panel]');
  var scrim = drawer.querySelector('[data-drawer-scrim]');
  var state = { open: false, lastFocused: null };
  var prevHeaderZ = '';
  var ignoreClicksUntil = 0;

  // removed hotspot overlay approach

  function positionUnderHeader() {
    var targetHeader = header || document.querySelector('.section-header');
    var rect = targetHeader ? targetHeader.getBoundingClientRect() : null;
    var viewportH = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    var topPx = rect ? Math.max(0, rect.bottom) : 64;
    var panelHeight = Math.max(0, viewportH - topPx);
    panel.style.top = topPx + 'px';
    panel.style.height = panelHeight + 'px';
    scrim.style.top = topPx + 'px';
  }

  function setHeaderHeightVar() {
    var sticky = document.querySelector('.section-header');
    var h = sticky ? sticky.getBoundingClientRect().height : 64;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  function openDrawer() {
    if (state.open) return;
    state.open = true;
    state.lastFocused = document.activeElement;
    drawer.hidden = false;
    // Ensure initial styles are applied before toggling the open state on mobile Safari
    setHeaderHeightVar();
    positionUnderHeader();
    panel.style.willChange = 'transform';
    scrim.style.willChange = 'opacity';
    requestAnimationFrame(function() {
      // Force a reflow so the browser registers the initial translateX state
      void panel.getBoundingClientRect();
      requestAnimationFrame(function() {
        drawer.classList.add('is-opening');
        drawer.classList.add('is-open');
        html.classList.add('menu-drawer-open');
        toggles.forEach(function(t){ t.setAttribute('aria-expanded', 'true'); });
        if (header) {
          header.classList.add('shopify-section-header-sticky');
          header.classList.remove('shopify-section-header-hidden');
          if (stickyEl) stickyEl.dispatchEvent(new Event('preventHeaderReveal', { bubbles: true }));
          prevHeaderZ = header.style.zIndex;
          header.style.zIndex = '10000';
        }
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) {
          drawer.classList.add('is-fully-open');
        } else {
          var onOpenEnd = function(e){
            if (e && e.target !== panel) return;
            panel.removeEventListener('transitionend', onOpenEnd);
            drawer.classList.remove('is-opening');
            drawer.classList.add('is-fully-open');
          };
          panel.addEventListener('transitionend', onOpenEnd, { once: true });
        }
        ignoreClicksUntil = Date.now() + 450;
      });
    });
  }

  function closeDrawer(focusToggle) {
    if (!state.open) return;
    state.open = false;
    drawer.classList.remove('is-opening');
    drawer.classList.remove('is-fully-open');
    drawer.classList.remove('is-open');
    html.classList.remove('menu-drawer-open');
    toggles.forEach(function(t){ t.setAttribute('aria-expanded', 'false'); });

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var end = function() {
      drawer.hidden = true;
      panel.removeEventListener('transitionend', end);
      panel.style.top = '';
      panel.style.height = '';
      scrim.style.top = '';
      panel.style.willChange = '';
      scrim.style.willChange = '';
      if (header) header.style.zIndex = prevHeaderZ || '';
      if (focusToggle !== false && state.lastFocused) {
        try { state.lastFocused.focus({ preventScroll: true }); } catch (e) {}
      }
    };

    if (prefersReduced) { end(); }
    else { panel.addEventListener('transitionend', end, { once: true }); }
  }

  // Delegated clicks for toggles (covers cloned/sticky headers)
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-drawer-toggle]');
    if (!t) return;
    e.preventDefault();
    document.documentElement.classList.remove('user-is-tabbing');
    if (state.open) closeDrawer(); else openDrawer();
  });
  // Explicit close hook
  document.addEventListener('click', function(e){
    var c = e.target.closest('[data-drawer-close]');
    if (!c) return;
    var isScrim = !!e.target.closest('[data-drawer-scrim]');
    if (isScrim && Date.now() < ignoreClicksUntil) return;
    e.preventDefault();
    closeDrawer();
  });
  scrim.addEventListener('click', function() { closeDrawer(); });

  // Key handling
  document.addEventListener('keydown', function(e) {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
    } else if (e.key === 'Tab') {
      // Focus trap
      var focusables = getFocusable(drawer);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (!drawer.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  // Submenu toggles (optional)
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-submenu-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('aria-controls');
    if (!id) return;
    var submenu = drawer.querySelector('#' + CSS.escape(id));
    if (!submenu) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    submenu.hidden = expanded;
  });

  // Close on navigation
  drawer.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    if (link) closeDrawer(false);
  });

  // Ensure stability across Shopify section reloads
  document.addEventListener('shopify:section:load', function(){
    if (!document.getElementById('MobileDrawer')) return;
    if (state.open) {
      // Re-apply intent so new markup adopts open state
      window.__drawerIntendedOpen = true;
    }
  });

  // Keep header height synced while open (resize/scroll)
  window.addEventListener('resize', function() { if (state.open) setHeaderHeightVar(); }, { passive: true });
  window.addEventListener('scroll', function() { if (state.open) setHeaderHeightVar(); }, { passive: true });
  window.addEventListener('resize', function() { if (state.open) positionUnderHeader(); }, { passive: true });
  window.addEventListener('scroll', function() { if (state.open) positionUnderHeader(); }, { passive: true });
  // hotspot sync removed
})();


